import styles from "./ChoiceChips.module.css";

interface Props {
  options: string[];
  disabled?: boolean;
  onPick: (value: string) => void;
}

/** A row of one-tap reply buttons shown under a bot turn. */
export function ChoiceChips({ options, disabled, onPick }: Props) {
  if (options.length === 0) return null;
  return (
    <div className={styles.row}>
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={styles.chip}
          disabled={disabled}
          onClick={() => onPick(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
